'use strict';

require('./small-toggle.scss');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Toggle = _react2['default'].createClass({
    displayName: 'Toggle',
    handleClick: function handleClick() {
        if (this.props.onClick) {
            this.props.onClick();
        }
    },
    render: function render() {
        return _react2['default'].createElement(
            'div',
            { className: 'rx-toggle ' + (this.props.on ? ' on' : 'off'), onClick: this.handleClick },
            _react2['default'].createElement(
                'span',
                { className: 'off-label uppercase' },
                this.props.offLabel
            ),
            _react2['default'].createElement(
                'div',
                { className: 'switch' },
                _react2['default'].createElement('div', { className: 'switch-button' })
            ),
            _react2['default'].createElement(
                'span',
                { className: 'on-label uppercase' },
                this.props.onLabel
            )
        );
    }
});

module.exports = Toggle;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/small-toggle.jsx
 ** module id = 1159
 ** module chunks = 0
 **/